module.exports = __webpack_public_path__ + "img/5.d5354b9f.svg";